<template>
  <div style="height:100vh">
    <div id="placeholderEditor"></div>
  </div>
</template>

<script>
import { TOKEN_KEY } from "@/libs/util";
import Cookies from "js-cookie";

var docEditor;

//var fileName = "@(docEditor.FileName)";
//var storagePath = "@(docEditor.StoragePath)";
//var fileId = "@(docEditor.FileId)";
//var fileType = "docx";
//var fileNameWithUser = "@(docEditor.FileNameWithUser)";
//var fileGuidName = "@(docEditor.GuidName)";
var innerAlert = function(message) {
  if (console && console.log) console.log(message);
};
import { mapActions } from "vuex";
import { request } from "@/api/all";
//import { EditorFileInfo } from "@/api/media";

export default {
  name: "editorComponent",

  data() {
    return {
      actionURL: "",
      fileName: "",
      fileType: "",
      fileUrl: "",
      key: "",
      vkey: "",
      callbackUrl: "",
      documentType: "",
      canEdit: false,
      authorName: "",
      editorName: "",
      editorId: "",
      date: "",
      hostUrl:""
    };
  },
  mounted() {
    if (this.$route.params.id != undefined) {
      let _obj = this.$store.state.app.mainLayoutConfig;
      _obj.aside = false;
      _obj.header = 0;
      _obj.footer = false;
      this.handleMainLayoutConfig(_obj);

      this.hostUrl=window.location.protocol+"//"+window.location.hostname;
      //console.log(this.hostUrl)
      //EditorFileInfo({ id: this.$route.params.id })
      request({
        api: { method: "get", url: "Media/EditorFileInfo" },
        params: {
          id: this.$route.params.id
        },
        store: this.$store
      })
      .then(res => {
        //this.otCompName = res.data.task.otCompName;
        //this.$route.meta.title = res.data.task.t;
        this.fileName = res.data.file.fileName;
        this.fileType = res.data.file.extension;
        this.callbackUrl =
          res.data.file.callbackUrl + "&access_token=" + Cookies.get(TOKEN_KEY);
        this.fileUrl = res.data.file.url;
        this.key = res.data.file.key;
        this.vkey = res.data.file.vkey;
        this.documentType = res.data.file.documentType;
        this.canEdit = res.data.file.canEdit;
        this.authorName = res.data.file.authorName;
        this.editorName = res.data.file.editorName;
        this.editorId = res.data.file.editorId;
        this.date = res.data.file.date;
        this.init();
      });
    }
  },
  methods: {
    ...mapActions(["handleMainLayoutConfig", "handleLoading"]),
    onReady() {
      //innerAlert("Document editor ready");
    },
    onRequestHistoryClose(event) {
      document.location.reload();
    },
    onDocumentStateChange(event) {
      var title = document.title.replace(/\*$/g, "");
      document.title = title + (event.data ? "*" : "");
      // document.title = event.data;
    },
    onRequestEditRights() {
      if (typeof DocsAPI.DocEditor.version == "function") {
        var version = DocsAPI.DocEditor.version();
        //console.log(version);
        if ((parseFloat(version) || 0) >= 3) {
          location.href = location.href.replace(
            RegExp("action=view&?", "i"),
            ""
          );
          return;
        }
      }
      docEditor.applyEditRights(true);
    },

    init() {
      docEditor = new DocsAPI.DocEditor("placeholderEditor", {
        width: "100%",
        height: "100%",
        type: "desktop",
        documentType: this.documentType,
        document: {
          title: this.fileName,
          url: this.fileUrl,
          fileType: this.fileType,
          key: this.key,
          vkey: this.vkey,

          info: {
            author: this.authorName,
            created: this.date
          },

          permissions: {
            edit: this.canEdit,
            download: true
          }
        },
        editorConfig: {
          mode: "edit",
          lang: "en-EN",
          callbackUrl: this.callbackUrl,
          user: {
            id: this.editorId,
            firstname: this.editorName,
            lastname: ""
          },
          embedded: {
            saveUrl: this.fileUrl,
            toolbarDocked: "top"
          },
          customization: {
            //loaderName:"Dynamic platform",
            //loaderLogo: "https://api.gosmart.mn/img/logo1.png",

            logo: {
              image: "https://api.gosmart.mn/img/logo1.png",
              imageEmbedded: "https://api.gosmart.mn/img/logo.png?w=100",
              url: "http://gosmart.mn"
            },
            backgroundColor: "#000",
            textColor: "#000",
            customer: {
              name: "Динамик Оффис",
              address: "Монгол улс, Улаанбаатар хот",
              mail: "gosmartmn@gmail.com",
              www: "www.gosmart.mn",
              info: "Gosmart TM LLC",
              logo: "https://api.gosmart.mn/img/logo1.png"
            },
            about: false,
            feedback: {
              visible: false,
              url: "https://www.gosmart.mn"
            },
            goback: {
              visible: false,
              text: "Идэвхтэй цонхыг хаана уу",
              url: this.hostUrl //"http://api.gosmart.mn/media/explorer"
            },
            chat: true,
            comments: true,
            showReviewChanges: true
          }
        },
        events: {
          onReady: this.onReady,
          onDocumentStateChange: this.onDocumentStateChange,
          onRequestEditRights: this.onRequestEditRights,
          onError: this.onError,
          //"onCollaborativeChanges": onCollaborativeChanges,
          //"onRequestHistory": onRequestHistory,
          //"onRequestHistoryData": onRequestHistoryData,
          onRequestHistoryClose: this.onRequestHistoryClose
        }
      });
    }
  }
};
</script>